import { registerPlugin } from '@capacitor/core';

const LiveKitNative = registerPlugin('LiveKitNative');

export async function nativeConnect(url, token) {
  return LiveKitNative.connect({ url, token });
}
export async function nativeSetMic(enabled) {
  return LiveKitNative.setMicrophoneEnabled({ enabled });
}
export async function nativeSetEchoCancellation(enabled) {
  return LiveKitNative.setMicEchoCancellation({ enabled });
}
export async function nativeSetRemoteVolume(identity, volume) {
  return LiveKitNative.setRemoteVolume({ identity, volume });
}
export async function nativeDisconnect() {
  return LiveKitNative.disconnect();
}
export function onNative(event, cb) {
  return LiveKitNative.addListener(event, cb);
}

export default LiveKitNative;